<script>
import ChannelMixin from "./channel-mixin"
import ChannelPostMenu from "./channel-post-menu.vue"
import MessageComposer from "./message-composer.vue"
import ImageViewer from "./image-viewer.vue"

export default {
  name: 'TeamChannel',
  mixins: [ChannelMixin],
  components: {ChannelPostMenu, MessageComposer, ImageViewer},
  props: {
    navRelative: {type: Boolean, default: false},
    // Read-only channel (e.g. an exhibitor's public channel seen by a
    // non-crew member): posts stay readable, the composer and the reply
    // actions are hidden. Reactions remain available.
    readOnly: {type: Boolean, default: false},
  },
}
</script>

<template>
<span>
  <div ref="postList" class="c-flex">
    <div v-if="orderedPostIds.length" class="list-group">

      <div v-if="prevPostId" class="list-group-item text-center">
        <span class="btn" @click.prevent="fetchOlderPosts">
          <i class="fas fa-chevron-up"></i>
        </span>
      </div>

      <div v-for="(pid, i) in orderedPostIds" :key="pid" class="list-group-item"
      >
        <div v-if="i === 0 || getDayLabel(posts[orderedPostIds[i-1]].created_at) !== getDayLabel(posts[pid].created_at)"
             class="text-center my-2">
          <small class="text-muted">── {{ getDayLabel(posts[pid].created_at) }} ──</small>
        </div>

        <channel-post-menu
         v-if="posts[pid].showMenu"
         :post="posts[pid]"
         :likes-only="readOnly"
         @like="reactToPost($event, 'heart')"
         @thumbsup="reactToPost($event, '+1')"
         @reply="replyToPost($event)"
         @reply-private="replyPrivateToPost($event)"
         @edit="editPost($event)"
         @delete="deletePost($event)"
        />

        <div class="d-flex">
          <img :src="avatars[posts[pid].user_id]" class="avatar" :alt="avatars[posts[pid].username]" />
          <div class="flex-grow-1 ms-2">
            <div @click="onPostClick(pid, $event)">
              <div>
                <b v-if="posts[pid].username">@{{ posts[pid].username }}:</b><span class="text-muted">&nbsp;{{ getFormatedDate(posts[pid].created_at) }}</span>
              </div>
              <div class="c-post" v-html="convert2Html(posts[pid].message)"></div>
            </div>
            <img class="img-thumbnail c-post-img" v-for="(image, idx) in postImages[pid]" :key="image.src" :src="image.src" :alt="image.name" @click="openImageViewer(postImages[pid], idx)" />
            <div v-if="postFiles[pid]">
              <a v-for="file in postFiles[pid]" :key="file.src" :href="file.src" target="_blank" class="d-block">
                <i class="fas fa-paperclip"></i> {{ file.name }}
              </a>
            </div>
            <div v-if="pid in postReactions">
              <button v-for="(v, k) in postReactions[pid]" :key="k" class="btn btn-sm btn-outline-light me-1"
               @click.prevent="reactToPost(pid, k)"
              >
                <span style="color: black">{{ emojis[k] || k }}&nbsp;{{ v.size }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="error" class="alert alert-danger">
      {{ error }}
    </div>
  </div>
  <image-viewer v-if="viewerImages" :images="viewerImages" :start-index="viewerIndex" @close="closeImageViewer" />
  <div v-if="readOnly" class="text-muted text-center my-2">
    <small><i class="bi bi-megaphone"></i> Nur das Ausstellerteam kann hier schreiben.</small>
  </div>
  <message-composer
    v-else
    v-model="postInput"
    :rows="currentRows"
    :nav-relative="navRelative"
    :nav-padding="navRelative"
    @send="postMessage"
    @file-selected="pendingFile = $event"
    ref="postInput"
  />
</span>
</template>

<style scoped>
.c-flex {
  flex: 1;
}
.avatar {
  height:30px;
  width:30px;
  object-fit:cover;
  border-radius:50%;
  overflow:hidden;
}
.c-post-img {
  max-height: 40vh;
  cursor: pointer;
}
</style>